import { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { SlidersHorizontal } from "lucide-react";
import { FilterActions } from "./FilterActions";

interface FiltersCardProps {
  children: ReactNode;
  appliedCount: number;
  isDirty: boolean;
  isLoading: boolean;
  onApply: () => void;
  onClear: () => void;
  onRefresh: () => void;
}

/**
 * Card que agrupa os filtros de cada tab, com o resumo do que está aplicado e
 * as ações de aplicar / limpar / atualizar.
 */
export const FiltersCard = ({
  children,
  appliedCount,
  isDirty,
  isLoading,
  onApply,
  onClear,
  onRefresh,
}: FiltersCardProps) => (
  <Card>
    <CardHeader className="pb-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <SlidersHorizontal className="h-4 w-4 text-muted-foreground" />
          <CardTitle className="text-base">Filtros</CardTitle>

          {appliedCount > 0 && (
            <Badge variant="secondary">
              {appliedCount} {appliedCount === 1 ? "filtro ativo" : "filtros ativos"}
            </Badge>
          )}
        </div>

        {isDirty && (
          <span className="text-xs font-medium text-amber-700 dark:text-amber-400">
            Alterações não aplicadas — clique em Filtrar.
          </span>
        )}
      </div>
    </CardHeader>

    <CardContent className="space-y-4">
      {children}

      <div className="border-t pt-4">
        <FilterActions
          isDirty={isDirty}
          isLoading={isLoading}
          onApply={onApply}
          onClear={onClear}
          onRefresh={onRefresh}
        />
      </div>
    </CardContent>
  </Card>
);
